<template>
  <div class="terms">
    <div class="container">
      <h1>Termos e Política de Privacidade</h1>
      <p>
        A <b>Ulbrex Asset Management Ltda.</b>, gestora dos fundos
        <b
          >IMMOB I FUNDO DE INVESTIMENTO IMOBILIÁRIO - FII, IMMOB II FUNDO DE
          INVESTIMENTO IMOBILIÁRIO – FII e IMMOB III FUNDO DE INVESTIMENTO
          IMOBILIÁRIO – FII</b
        >, proprietários dos imóveis disponibilizados para venda através do
        Portal DezNoventa, está comprometida com a proteção da privacidade e dos
        dados pessoais dos seus clientes, parceiros e outros interessados. Por
        isso, apresenta este Aviso de Privacidade (“Aviso”) a fim de informar
        aos titulares sobre o tratamento de seus dados pessoais pela empresa,
        inclusive aqueles coletados mediante o uso de cookies. O aviso de
        privacidade é disponibilizado ao titular na primeira vez que ele acessa
        o site, mas se acha disponível para consulta a qualquer tempo. Ao clicar
        em “aceitar”, o titular confirma que leu o aviso de privacidade e
        concorda com todos os seus termos.
      </p>
      <br />
      <h2>Como são utilizados os dados pessoais</h2>
      <br />
      <p>
        De um modo geral, a Immob realiza o tratamento de dados pessoais para
        garantir o adequado funcionamento da empresa e a correta prestação dos
        serviços prestados aos correspondentes titulares. Abaixo, é possível
        conferir uma descrição das operações de tratamento realizadas pela
        empresa.
      </p>
      <br />
      <h3>Quais dados são coletados?</h3>
      <br />
      <p>
        Nome, e-mail, telefone, CPF, RG, órgão emissor do RG, filiação, data de
        nascimento endereço, nacionalidade, estado civil, regime de casamento,
        data de casamento, profissão, nome da empresa, confirmação se o titular
        é funcionário da Ulbrex ou do Banco Bradesco, endereço comercial, e-mail
        corporativo, cargo, admissão, telefone comercial, salário, se é pessoa
        exposta politicamente e assinatura. Dados relativos ao patrimônio do
        promitente comprador/comprador: fontes de renda, se o endereço
        residencial é próprio, alugado ou outros; endereço do imóvel, se é
        quitado e escriturado, veículo, marca do veículo, modelo do veículo, ano
        de fabricação do veículo, se é quitado; Dados financeiros e bancários do
        promitente comprador/comprador: identificação do banco, agência, cidade,
        data da abertura da conta, se possui cheque especial, valor do cheque
        especial, se possui cartão de crédito, valor do cartão de crédito. dados
        relativos ao parente do promitente comprador/comprador: nome, grau de
        parentesco e informações se trabalha na Ulbrex ou no Banco Bradesco ou
        se é pessoa exposta politicamente dados relativos ao cônjuge do
        promitente comprador\comprador: nome, CPF, RG, órgão emissor do RG,
        filiação, nacionalidade, data de nascimento, celular, e-mail. dados
        profissionais relativos ao cônjuge do promitente comprador/comprador:
        profissão, nome da empresa, endereço comercial, e-mail corporativo,
        cargo, admissão, telefone comercial e salário e informações se trabalha
        na Ulbrex ou no Banco Bradesco ou se é pessoa exposta politicamente.
      </p>
      <br />
      <h3>Para quais finalidades são utilizados os dados?</h3>
      <br />
      <p>
        Efetuar a venda de imóveis
      </p>
      <br />
      <h2>Uso de Cookies</h2>
      <br />
      <br />
      <h3>O que são Cookies</h3>
      <br />
      <p>
        Cookies são pequenos arquivos de textos armazenados no computador ou no
        dispositivo móvel (como um smartphone, por exemplo) quando o titular
        visita sites e outras páginas da web e que possuem funções variadas,
        conforme as finalidades para os quais são efetivamente utilizados –
        como, por exemplo, recordas as preferências de idioma do titular.
      </p>
      <br />
      <h3>Utilização dos Cookies</h3>
      <br />
      <p>
        A Immob utiliza cookies para assegurar o correto funcionamento dos sites
        e garantir a qualidade da experiência e da navegação do titular. Além
        disso, os cookies também são empregados para atender às seguintes
        finalidades: <br /><br />
        - Identificar e autenticar o Usuário adequadamente;<br />
        - Atender adequadamente às suas solicitações e dúvidas;<br />
        - Manter atualizados seus cadastros para fins de contato por telefone,
        correio eletrônico, SMS, ou por outros meios de comunicação;<br />
        - Aperfeiçoar o uso e a experiência interativa durante sua navegação no
        Portal;<br />
        - Efetuar estatísticas, estudos, pesquisas e levantamentos pertinentes
        às atividades do Usuário enquanto navegando pelo Portal;<br />
        - Promover outros produtos da empresa, além de informar sobre novidades,
        funcionalidades, conteúdos, notícias e demais informações relevantes
        para a manutenção do relacionamento com o titular.
      </p>
      <br />
      <h3>Dados pessoais coletados via Cookies</h3>
      <br />
      <p>
        A Immob coleta as informações e os dados pessoais inseridas ativamente
        pelo titular no Portal, bem como aqueles gerados automaticamente quando
        da utilização do Portal, tais como características do dispositivo de
        acesso, do navegador utilizado, do endereço IP com data, hora e origem
        do acesso, informações sobre cliques, páginas acessadas, entre outras.
      </p>
      <p>
        Além disso, a empresa possui parceiros comerciais que podem oferecer
        serviços por meio de funcionalidades ou sites acessados no Portal. Os
        dados fornecidos pelo titular a esses parceiros serão de
        responsabilidade desses, estando assim sujeitos às suas próprias
        práticas de obtenção e uso de dados, sem que caiba qualquer ônus da
        Immob pelo tratamento de tais informações.
      </p>
      <br />
      <h3>Gerenciamento de Cookies</h3>
      <br />
      <p>
        Os Cookies podem ser gerenciados pelo titular a qualquer tempo, sendo
        necessário alterar as configurações do dispositivo de acesso, conforme
        instruções disponibilizadas por cada fornecedor. Ressaltamos que parte
        das funções oferecidas pelo Portal pode não funcionar corretamente caso
        tais tecnologias sejam desabilitadas pelo titular.
      </p>
      <br />
      <br />
      <h3>Compartilhamento de dados pessoais</h3>
      <br />
      <p>
        Quando necessário, a Immob compartilhará os dados pessoais objetos de
        tratamento com outras empresas, entidades ou organizações a fim de
        viabilizar o desenvolvimento de suas atividades e processos internos,
        inclusive a venda dos imóveis aos potenciais compradores, bem como o
        cumprimento de obrigações legais ou regulatórias, por exemplo, com
        prestadores de serviço ou instituições financeiras. Sem esgotar todas as
        possibilidades, o compartilhamento de dados pessoais poderá ocorrer nas
        seguintes situações:<br /><br />
        - Para proteção dos interesses da empresa em qualquer tipo de conflito,
        inclusive demandas judiciais;<br />
        - Para realização de processos de auditoria das atividades da empresa,
        com as empresas/ órgãos envolvidos em tal processo de auditoria; ou
        <br />
        - Mediante ordem judicial ou requerimento de autoridades judiciais ou
        administrativas que detenham competência legal para tal requisição.
        <br />
      </p>
      <br />
      <h3>Proteção dos dados pessoais</h3>
      <br />
      <p>
        A Immob adota práticas, mecanismos, políticas e procedimentos com vistas
        a garantir a segurança dos dados pessoais objetos de tratamento pela
        empresa, inclusive aqueles coletados via Cookies, especialmente em face
        de acessos indevidos e incidentes de comunicação, perda, alteração ou
        destruição, observada a capacidade e a disponibilidade de recursos da
        empresa.
      </p>
      <br />
      <h3>Retenção dos dados pessoais</h3>
      <br />
      <p>
        A Immob retém os dados pessoais, inclusive aqueles coletados via
        Cookies, pelo período necessário ao cumprimento das finalidades que
        ensejaram o tratamento pela empresa, para o atendimento de obrigações
        legais e regulatórias a que se acha sujeita e para exercício regular dos
        direitos da empresa.
      </p>
      <br />
      <h3>Dos direitos dos titulares de dados pessoais</h3>
      <br />
      <p>
        A Immob assegura ao titular de dados pessoais o exercício dos direitos
        consagrados na LGPD, inclusive em relação aos dados coletados via
        Cookies, observados os limites aplicáveis, abaixo indicados:
        <br /><br />
        <b>- Confirmação do tratamento dos dados pessoais:</b> o titular poderá
        solicitar a confirmação de que a empresa realiza o tratamento de seus
        dados pessoais para atender algum objetivo legítimo e específico;<br /><br />

        <b>- Acesso aos dados pessoais:</b> além disso, titular poderá requerer
        o acesso aos seus dados pessoais custodiados pela empresa, respeitados
        os segredos comerciais e industriais da última;<br /><br />

        <b>- Informação sobre o compartilhamento dos dados pessoais:</b> é
        também direito do titular solicitar informações sobre o compartilhamento
        dos dados pessoais com outras empresas ou entidades públicas, caso ainda
        restem dúvidas após a leitura deste Aviso de Privacidade;<br /><br />

        <b>- Correção:</b> o titular poderá requerer a correção dos dados
        incorretos, imprecisos ou desatualizados objetos de tratamento pela
        empresa;<br /><br />

        <b>- Bloqueio, anonimização ou exclusão dos dados pessoais:</b> ademais,
        o titular poderá solicitar o bloqueio, anonimização ou eliminação dos
        dados pessoais tratados de forma desnecessária, excessiva ou em
        desconformidade com a LGPD pela empresa, ressalvadas as hipóteses legais
        de conservação previstas no art. 16, da LGPD;<br /><br />

        <b>- Revogação de consentimento:</b> o titular poderá revogar o
        consentimento anteriormente concedido à empresa a qualquer momento, de
        forma gratuita e simples, sendo exigido apenas manifestação expressa
        nesse sentido. Nessa hipótese, são válidos os tratamentos realizados até
        a revogação do consentimento pelo titular e a conservação dos
        respectivos dados pessoais, salvo se por ele solicitada a eliminação e
        desde que observadas as hipóteses de conservação estabelecidas no art.
        16, da LGPD.<br /><br />

        <b>- Oposição:</b> o titular poderá se opor ao tratamento realizado pela
        empresa, desde que a base legal indica seja diferente do consentimento e
        o tratamento esteja em desconformidade com a LGPD;<br /><br />

        <b>- Portabilidade dos dados pessoais:</b> por fim, o titular também
        poderá solicitar a portabilidade dos dados pessoais para outra empresa,
        excluídos os dados já anonimizados e resguardados os dados que
        constituam segredo comercial ou industrial da empresa.
      </p>
      <br />
      <h3>Como os direitos podem ser exercidos</h3>
      <br />
      <p>
        A Immob disponibiliza os seguintes canais de comunicação ao titular dos
        dados pessoais:
      </p>
      <br />
      <p>
        Encarregado de Proteção de Dados <br />
        encarregado@ulbrex.com <br />
        Rua Hungria, 620 – 3º andar, Jardim Europa - São Paulo – SP, Cep
        01455-000
      </p>
      <br />
      <p>
        Além disso, tais canais de atendimento também poderão ser utilizados
        pelo titular para tratar de quaisquer outros temas afetos à sua
        privacidade e ao tratamento de seus dados pessoais pela empresa.
      </p>
      <br />
      <h3>Disposições gerais</h3>
      <br />
      <p>
        A Immob poderá modificar o presente aviso de privacidade a qualquer
        tempo, sem prévia notificação ao titular, de modo a refletir de forma
        transparente e precisa o tratamento dos dados pessoais realizados pela
        empresa. Desse modo é recomendável que o titular permaneça atento à data
        de atualização do aviso de privacidade ao final do documento.
      </p>
      <br />
      <p>
        Além disso, o presente aviso de privacidade deverá ser interpretado
        segundo a legislação brasileira, sendo eleito o Foro da Comarca de São
        Paulo/SP para dirimir qualquer litígio ou controvérsia envolvendo o
        presente documento, salvo ressalva específica de competência pessoal,
        territorial ou funcional pela legislação aplicável.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsOfUse",

  setup() {}
};
</script>

<style lang="scss" scoped>
.terms {
  margin: 0 auto;
  min-height: 200px;

  .container {
    display: flex;
    height: 100%;
    flex-direction: column;
    max-width: 1200px;
    position: relative;
    margin-top: 150px;

    h1 {
      max-width: 500px;
      color: #2e2f32;
      line-height: 60px;
      font-size: var(--size-h1);
      font-weight: bold;
      font-family: var(--font-primary);
      padding-bottom: 80px;
    }

    p {
      font-size: var(--size-large);
      font-weight: var(--weight-light);
      font-family: var(--font-primary);
      line-height: 38px;
      color: #414f54;
    }
  }
}

@media screen and (max-width: 768px) {
  .container {
    padding: 0 50px 0 50px;
  }
}
</style>
